// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"d0ed9e0c","703":"3f3662f5","787":"680f37cb"}[chunkId] + ".chunk.js";
};